var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"compareContractsPage"}},[_c('MainLayout',[_c('b-row',{attrs:{"id":"compareMultipleContracts"}},[_c('CompareMultipleContracts')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }